/**
 * Loading Component
 * A reusable loading spinner/indicator component
 *
 * TODO: Implement your loading component here
 *
 * Example props:
 * - size: "sm" | "md" | "lg"
 * - fullScreen: boolean
 * - text: string
 */

interface LoadingProps {
  text?: string;
  size?: "sm" | "md" | "lg";
  fullScreen?: boolean;
}

export default function Loading({
  text = "Loading...",
  size = "md",
  fullScreen = false,
}: LoadingProps) {
  const spinnerSize =
    size === "sm" ? "h-4 w-4" : size === "lg" ? "h-8 w-8" : "h-6 w-6";
  return (
    <div
      className={`flex items-center justify-center gap-3 p-8 text-muted-foreground ${fullScreen ? "min-h-screen" : ""}`}
      role="status"
    >
      <span
        className={`${spinnerSize} animate-spin rounded-full border-2 border-border border-t-brand-primary`}
        aria-hidden="true"
      />
      <span>{text}</span>
    </div>
  );
}
